jQuery(document).ready(function($) {

    var $range = $(".js-range-slider"),
    $inputFrom = $("[name='budgetFrom']"),
    $inputTo = $("[name='budgetTo']"),
    instance,
    min = 2000,
    max = 400000,
    from = 0,
    to = 0;

    var custom_values = [2000,2500,3000,4000,5000,8000,10000,1200,15000,25000,50000,75000,100000,100500,200000,200500,300000,300500,400000];

    var my_from = custom_values.indexOf(2000);
    var my_to = custom_values.indexOf(400000);

    $range.ionRangeSlider({
        skin: "square",
        type: "double",
        min: min,
        max: max,
        from: my_from,
        to: my_to,
        values: custom_values,
        onStart: updateInputs,
        onChange: updateInputs,
    });

    instance = $range.data("ionRangeSlider");

    function updateInputs (data) {
        //console.log(data);
        from = data.from_value;
        to = data.to_value;

        $inputFrom.prop("value", from);
        $inputTo.prop("value", to);

    }

    $inputFrom.on("input", function () {

        var val = $(this).prop("value");

        // validate
        if (val < min) {
            val = min;
        } else if (val > to) {
            val = to;
        }

        instance.update({
            from: val
        });

    });

    $inputTo.on("input", function () {

        var val = $(this).prop("value");

        // validate
        if (val < from) {
            val = from;
        } else if (val > max) {
            val = max;
        }

        instance.update({
            to: val
        });

    });

});